import React from 'react'
import styled, { css } from 'styled-components'
import { Range } from 'react-range'

interface Props {
  value: number
  max?: number
  min?: number
  step?: number
  buffered?: number
  onChange(value: number): void
}

const Slider: React.FC<Props> = ({ value, max = 100, min = 0, step = 1, buffered, onChange }) => {
  const percentValue = ((value / max) * 100) | 0
  const percentBuffered = buffered ? ((buffered / max) * 100) | 0 : percentValue

  const onRangeChange = (values: number[]) => {
    onChange(values[0])
  }

  return (
    <Container>
      <Range
        values={[value]}
        step={step}
        min={min}
        max={max}
        onChange={onRangeChange}
        renderTrack={({ props, children }) => (
          <Track onMouseDown={props.onMouseDown} onTouchStart={props.onTouchStart}>
            <TrackBackground value={percentValue} buffered={percentBuffered} ref={props.ref}>
              {children}
            </TrackBackground>
          </Track>
        )}
        renderThumb={({ props }) => <Thumb {...props} />}
      />
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`

const Track = styled.div`
  height: 35px;
  display: flex;
  width: 100%;
  cursor: pointer;
`

const TrackBackground = styled.div<{ value: number; buffered: number }>(
  (p) => css`
    height: 5px;
    width: 100%;
    border-radius: 4px;
    align-self: center;
    background: ${`linear-gradient(to right, 
    ${p.theme.colors.white} ${p.value}%, 
    ${p.theme.colors.gray6} ${p.value}% ${p.buffered}%,
    ${p.theme.colors.gray8} ${p.buffered}% 100%)`};
  `,
)

const Thumb = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  height: 15px;
  background: white;
  border-radius: 50%;
  border: 1px solid ${(p) => p.theme.colors.gray8};
  transform: translate(-8.5px, -6px);

  &:focus {
    outline: none;
  }
`

export default Slider
